import React from 'react'
import injectStyles from 'react-jss'
import styles from '../styles'

const ChatSpyHeaderInfoView = ({ headerLinks, classes }) => {
  return (
    <div className={classes.headerWrapper}>
      {headerLinks.length
        ? headerLinks.map(item => (
            <a href={item.link} target="blank" key={item.title}>
              [ {item.title} ]
            </a>
          ))
        : null}
    </div>
  )
}
export default injectStyles(styles)(ChatSpyHeaderInfoView)



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatMessagesList/component/ChatSpyHeaderInfoView.js